import { useParams, useNavigate, useLocation } from "react-router-dom";
import { MainLocationTab } from "./MainTabs/MainLocationTab";
import MobileScreenSettings from "./MobileScreenSettings";
import GlobalWayfinderButtonSettings from "./GlobalWayfinderButtonSettings";
import GlobalAvatarSettings from "./GlobalAvatarSettings";
import LocationSelector from "./LocationSelector";
import BrandingSettings from "./BrandingSettings";
import MapSettings from "./MapSettings";
import { getLanguageText, truncateLanguageText } from "../../utils/multilanguageUtils";

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import useS3Upload from "../../hooks/useS3Upload";

import {
  Tabs,
  Tab,
  Box,
  Typography,
  Fade,
  Button,
  Paper,
  Grid,
  IconButton,
  Chip,
  Alert,
  CircularProgress,
  Avatar,
  Slide,
  Tooltip as MuiTooltip,
} from "@mui/material";
import UseToast from "../UseToast";
import WayfinderCard from "./WayfinderCard";
import { Link } from "react-router-dom";
import SubCategoryView from "./SubCategoryView";
import MainWayfinderMedia from "./MainWayfinderMedia";
import MainTextPage from "./MainTextPage";
import CategorySlidePanelForm from "./CategorySlidePanelForm";

import { MainBrandingTab } from "./MainTabs/MainBrandingTab";
import BulkCaptionUpload from "./BulkCaptionUpload";
import BulkVideoUpload from "./BulkVideoUpload";
import TagManager from "./TagManager";

export const WayfinderMain = () => {
  const [buttonColor, setButtonColor] = useState("#000000");
  const { id, userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [wayfinderEnabled, setWayfinderEnabled] = useState(false);

  // Language support
  const [availableLanguages, setAvailableLanguages] = useState(['en']);
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [loadingLanguages, setLoadingLanguages] = useState(false);

  const [subValue, setSubValue] = useState(0); // For sub-tabs under Category Manager
  const { showMsgSuccessToast, showErrorToast } = UseToast();

  const isEffectRan = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [categoryData, setCategoryData] = useState({
    status: true,
    videoTime: 0,
  });



  // Track which data has been fetched to prevent duplicate calls
  const fetchedData = useRef({
    wayfinder: false,
    categoryMedia: false,
    categoryText: false,
    subcategoryMedia: false,
    subcategoryText: false,
    locations: false,
    sublocations: false,
    settings: false,
    subCategorySettings: false,
  });

  // S3 Upload hook for Main Category
  const { uploadFile: uploadToS3, uploading: s3Uploading } = useS3Upload({
    signedUrlEndpoint: "/generate-signed-url",
    onSuccess: (fileUrl, file) => {
      showMsgSuccessToast(`${file.name} uploaded successfully`);
    },
    onError: (error) => {
      showErrorToast("Failed to upload file");
      console.error("Upload error:", error);
    },
  });

  // S3 Upload hook for Main SubCategory
  const {
    uploadFile: uploadToS3SubCategory,
    uploading: s3UploadingSubCategory,
  } = useS3Upload({
    signedUrlEndpoint: "/generate-signed-url",
    onSuccess: (fileUrl, file) => {
      showMsgSuccessToast(`${file.name} uploaded successfully`);
    },
    onError: (error) => {
      showErrorToast("Failed to upload file");
      console.error("Upload error:", error);
    },
  });

  // States for Category Manager
  const [categories, setCategories] = useState([]);
  const [frontendCategories, setFrontendCategories] = useState([]);
  const [frontCategoryName, setFrontCategoryName] = useState("");
  const [frontendSubCategories, setFrontendSubCategories] = useState([]);
  const [showSubCategoryView, setShowSubCategoryView] = useState(false);
  const [selectedCategoryForSubView, setSelectedCategoryForSubView] =
    useState(null);
  const [selectedParentCategories, setSelectedParentCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [allSubCategories, setAllCategories] = useState([]);
  const [isPrimary, setIsPrimary] = useState(false);
  const [parentMenuName, setParentMenuName] = useState("");
  const [chilmenuName, setChildMenuName] = useState("");
  const [parentMenuID, SetParentMenuID] = useState(null);
  const [linkbtnId, setLinkedBtnId] = useState(null);
  const [menuLevel, setMenuLevel] = useState("");
  const [mainMeuLinked, setMainMeuLinked] = useState(false);
  const [menuUrl, setMenuUrl] = useState("");

  const [loadingText, setLoadingText] = useState(false);

  const [mainTextSections, setMainTextSections] = useState({
    header: {
      enabled: true,
      text: "Main Category Header",
      color: "#000000",
      fontSize: 24,
      fontWeight: 400,
      textAlign: "center",
      opacity: 1,
      textShadowH: "2",
      textShadowV: "2",
      textShadowBlur: "4",
      textShadowColor: "#000000",
      marginTop: 10,
      marginBottom: 10,
      fontFamily: "Arial",
    },
    description: {
      enabled: true,
      text: "This is the description text. Customize it as needed.",
      color: "#000000",
      fontSize: 16,
      fontWeight: 400,
      textAlign: "left",
      opacity: 1,
      textShadowH: "0",
      textShadowV: "0",
      textShadowBlur: "0",
      textShadowColor: "#000000",
      marginTop: 10,
      marginBottom: 10,
      fontFamily: "Arial",
    },
    footer: {
      enabled: true,
      text: "Footer text goes here",
      color: "#000000",
      fontSize: 14,
      fontWeight: 400,
      textAlign: "center",
      opacity: 0.8,
      textShadowH: "0",
      textShadowV: "0",
      textShadowBlur: "0",
      textShadowColor: "#000000",
      marginTop: 10,
      marginBottom: 10,
      fontFamily: "Arial",
    },
    searchConfig: {
      enabled: true,
      buttonText: "Search",
      cornerRadius: 0,
      height: 50,
      width: 150,
      outlineColor: "#000000",
      outlineThickness: 1,
      fillColor: "#ffffff",
      font: "Arial",
      fontColor: "#127E10",
      fontSize: 16,
      textAlign: "center",
      marginBottom: 2,
      lineHeight: 1,
      padding: 10,
      shadow: {
        angle: 5,
        size: 10,
        distance: 5,
        alpha: 0.5,
        color: "#FF5733",
      },
      highlight: {
        borderColor: "#000000",
        fillColor: "#ffffff",
        fontColor: "#000000",
      },
      clickSound: "",
      clickSoundFilename: null,
      clickSoundVolume: 1,
      pngBtnenabled: false,
      hideBtnText: false,
      btnPng: null,
      btnPngFileName: null,
    },
  });

  // Main SubCategory Settings States
  const [mainSubCategoryTextSections, setMainSubCategoryTextSections] =
    useState({
      header: {
        enabled: true,
        text: "Main SubCategory Header",
        color: "#000000",
        fontSize: 24,
        fontWeight: 400,
        textAlign: "center",
        opacity: 1,
        textShadowH: "2",
        textShadowV: "2",
        textShadowBlur: "4",
        textShadowColor: "#000000",
        marginTop: 10,
        marginBottom: 10,
        fontFamily: "Arial",
      },
      description: {
        enabled: true,
        text: "This is the description text. Customize it as needed.",
        color: "#000000",
        fontSize: 16,
        fontWeight: 400,
        textAlign: "left",
        opacity: 1,
        textShadowH: "0",
        textShadowV: "0",
        textShadowBlur: "0",
        textShadowColor: "#000000",
        marginTop: 10,
        marginBottom: 10,
        fontFamily: "Arial",
      },
      footer: {
        enabled: true,
        text: "Footer text goes here",
        color: "#000000",
        fontSize: 14,
        fontWeight: 400,
        textAlign: "center",
        opacity: 0.8,
        textShadowH: "0",
        textShadowV: "0",
        textShadowBlur: "0",
        textShadowColor: "#000000",
        marginTop: 10,
        marginBottom: 10,
        fontFamily: "Arial",
      },
      searchConfig: {
        enabled: true,
        buttonText: "Search",
        cornerRadius: 0,
        height: 50,
        width: 150,
        outlineColor: "#000000",
        outlineThickness: 1,
        fillColor: "#ffffff",
        font: "Arial",
        fontColor: "#127E10",
        fontSize: 16,
        textAlign: "center",
        marginBottom: 2,
        lineHeight: 1,
        padding: 10,
        shadow: {
          angle: 5,
          size: 10,
          distance: 5,
          alpha: 0.5,
          color: "#FF5733",
        },
        highlight: {
          borderColor: "#000000",
          fillColor: "#ffffff",
          fontColor: "#000000",
        },
        clickSound: "",
        clickSoundFilename: null,
        clickSoundVolume: 1,
        pngBtnenabled: false,
        hideBtnText: false,
        btnPng: null,
        btnPngFileName: null,
      },
    });

  const [uploadedUrlsSubCategory, setUploadedUrlsSubCategory] = useState({
    upperLeft: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    upperRight: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    bottomLeft: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    bottomRight: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
  });

  const [uploadingStatesSubCategory, setUploadingStatesSubCategory] = useState({
    upperLeft: false,
    upperRight: false,
    bottomLeft: false,
    bottomRight: false,
  });

  const [subCategoryData, setSubCategoryData] = useState({
    status: true,
    videoTime: 0,
  });

  const [loadingMediaSubCategory, setLoadingMediaSubCategory] = useState(false);
  const [loadingTextSubCategory, setLoadingTextSubCategory] = useState(false);



  const [uploadingStates, setUploadingStates] = useState({
    upperLeft: false,
    upperRight: false,
    bottomLeft: false,
    bottomRight: false,
  });

  const [uploadedUrls, setUploadedUrls] = useState({
    upperLeft: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    upperRight: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    bottomLeft: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
    bottomRight: {
      fileName: "",
      fileUrl: "",
      enabled: false,
      width: "100",
      height: "100",
    },
  });

  const handleTabChange = (_event, newValue) => {
    // Tab route mapping
    const getTabRoute = (index) => {
      const routes = wayfinderEnabled 
        ? [
            `/view-button-settings/${userId}`, // Main Menu
            `/wayfinder/categories/${userId}`,  // Category's
            `/wayfinder/locations/${userId}`,   // Locations
            `/wayfinder/all-locations/${userId}`, // All Locations
            `/wayfinder/branding/${userId}`,    // Branding & QR
            `/wayfinder/mobile/${userId}`,      // Mobile
            `/wayfinder/global/${userId}`,      // Global
            `/wayfinder/avatar/${userId}`,      // Avatar API
            `/wayfinder/map/${userId}`,         // MAP
            `/wayfinder/captions/${userId}`,    // Captions
            `/wayfinder/videos/${userId}`,      // Videos
            `/wayfinder/tags/${userId}`,        // TAGS
          ]
        : [
            `/wayfinder/categories/${userId}`,  // Category's
            `/wayfinder/locations/${userId}`,   // Locations
            `/wayfinder/all-locations/${userId}`, // All Locations
            `/wayfinder/branding/${userId}`,    // Branding & QR
            `/wayfinder/mobile/${userId}`,      // Mobile
            `/wayfinder/global/${userId}`,      // Global
            `/wayfinder/avatar/${userId}`,      // Avatar API
            `/wayfinder/map/${userId}`,         // MAP
            `/wayfinder/captions/${userId}`,    // Captions
            `/wayfinder/videos/${userId}`,      // Videos
            `/wayfinder/tags/${userId}`,        // TAGS
          ];
      
      return routes[index];
    };

    const route = getTabRoute(newValue);
    if (route) {
      navigate(route);
    }
  };

  // Calculate current tab value based on route
  const getCurrentTabValue = () => {
    const currentPath = location.pathname;
    
    // Define route patterns
    const routePatterns = wayfinderEnabled
      ? [
          { pattern: '/view-button-settings/', index: 0 },
          { pattern: '/wayfinder/categories/', index: 1 },
          { pattern: '/wayfinder/locations/', index: 2 },
          { pattern: '/wayfinder/all-locations/', index: 3 },
          { pattern: '/wayfinder/branding/', index: 4 },
          { pattern: '/wayfinder/mobile/', index: 5 },
          { pattern: '/wayfinder/global/', index: 6 },
          { pattern: '/wayfinder/avatar/', index: 7 },
          { pattern: '/wayfinder/map/', index: 8 },
          { pattern: '/wayfinder/captions/', index: 9 },
          { pattern: '/wayfinder/videos/', index: 10 },
          { pattern: '/wayfinder/tags/', index: 11 },
        ]
      : [
          { pattern: '/wayfinder/categories/', index: 0 },
          { pattern: '/wayfinder/locations/', index: 1 },
          { pattern: '/wayfinder/all-locations/', index: 2 },
          { pattern: '/wayfinder/branding/', index: 3 },
          { pattern: '/wayfinder/mobile/', index: 4 },
          { pattern: '/wayfinder/global/', index: 5 },
          { pattern: '/wayfinder/avatar/', index: 6 },
          { pattern: '/wayfinder/map/', index: 7 },
          { pattern: '/wayfinder/captions/', index: 8 },
          { pattern: '/wayfinder/videos/', index: 9 },
          { pattern: '/wayfinder/tags/', index: 10 },
        ];

    // Find matching route
    const match = routePatterns.find(({ pattern }) => currentPath.includes(pattern));
    return match ? match.index : (wayfinderEnabled ? 1 : 0);
  };

  const goBack = () => {
    navigate(-1);
  };

  const filteredCategories = showSubCategoryView
    ? frontendCategories // Show all categories when subcategory view is open
    : frontendCategories.filter((cat) =>
      getLanguageText(cat.name, currentLanguage).toLowerCase().includes(searchTerm.toLowerCase()),
    );

  // Fetch available languages
  const fetchAvailableLanguages = async () => {
    try {
      setLoadingLanguages(true);
      // Fetch only enabled languages
      const response = await axios.get(`/api/language/enabled/${userId}`);
      if (response.data.success && response.data.languages) {


        const enabledLangCodes = response.data.languages;
        setAvailableLanguages(enabledLangCodes.length > 0 ? enabledLangCodes : ['en']);

        // Try to get saved language preference from localStorage
        const savedLang = localStorage.getItem(`language_pref_${userId}`);
        if (savedLang && enabledLangCodes.includes(savedLang)) {
          setCurrentLanguage(savedLang);
        } else {
          // Default to 'en' if available, otherwise use first language
          const defaultLang = enabledLangCodes.includes('en') ? 'en' : (enabledLangCodes[0] || 'en');
          setCurrentLanguage(defaultLang);
        }
      }
    } catch (error) {
      console.error('Error fetching languages:', error);
      setAvailableLanguages(['en']);
      setCurrentLanguage('en');
    } finally {
      setLoadingLanguages(false);
    }
  };

  // Function to change language
  const handleLanguageChange = async (langCode) => {
    setCurrentLanguage(langCode);

    // Save preference to localStorage
    localStorage.setItem(`language_pref_${userId}`, langCode);

    // Refresh data with new language
    fetchedData.current = {
      wayfinder: false,
      categoryMedia: false,
      categoryText: false,
      subcategoryMedia: false,
      subcategoryText: false,
      locations: false,
      sublocations: false,
      settings: false,
      subCategorySettings: false,
    };

    // Refetch data based on current tab
    const currentTabValue = getCurrentTabValue();
    const actualValue = wayfinderEnabled ? currentTabValue - 1 : currentTabValue;
    if (actualValue === 0) {
      await fetchWayfinderData();
    } else if (actualValue === 2) {
      await fetchLocations();
    }

    showMsgSuccessToast(`Language changed to ${getLanguageName(langCode)}`);
  };

  // Helper function to get language name
  const getLanguageName = (code) => {
    if (!code) return 'Unknown';

    const languageNames = {
      en: 'English',
      es: 'Spanish',
      fr: 'French',
      de: 'German',
      it: 'Italian',
      pt: 'Portuguese',
      ru: 'Russian',
      zh: 'Chinese',
      ja: 'Japanese',
      ko: 'Korean',
      ar: 'Arabic',
      hi: 'Hindi',
      tr: 'Turkish',
      nl: 'Dutch',
      sv: 'Swedish',
      pl: 'Polish',
      th: 'Thai',
      vi: 'Vietnamese',
      id: 'Indonesian',
    };
    return languageNames[code] || code.toUpperCase();
  };

  // Helper function to get language flag
  const getLanguageFlag = (code) => {
    if (!code) return 'xx';

    const flagMap = {
      en: 'us',
      es: 'es',
      fr: 'fr',
      de: 'de',
      it: 'it',
      pt: 'pt',
      ru: 'ru',
      zh: 'cn',
      ja: 'jp',
      ko: 'kr',
      ar: 'sa',
      hi: 'in',
      tr: 'tr',
      nl: 'nl',
      sv: 'se',
      pl: 'pl',
      th: 'th',
      vi: 'vn',
      id: 'id',
    };
    return flagMap[code] || 'xx';
  };

  const handleViewSubCategories = async (category) => {
    try {
      setSelectedCategoryForSubView(category);
      setShowSubCategoryView(true);
      setSearchTerm("");

      // Fetch fresh subcategories for this category
      await handleFetchLinkingSubCategory(category._id);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleFetchLinkingSubCategory = async (categoryId) => {
    try {
      if (categoryId) {
        console.log("Fetching subcategories for category:", categoryId);

        // Fetch subcategories specifically for this category
        const subcategoriesResponse = await axios.get(
          `/api/wayfinder/subcategory/category/${categoryId}`,
        );

        console.log("Subcategories API response:", subcategoriesResponse.data);

        if (subcategoriesResponse.data.success) {
          const subCategoryData = subcategoriesResponse.data.dataSub || [];
          console.log("Setting filtered subcategories:", subCategoryData);
          setFilteredSubCategories(subCategoryData);
        } else {
          console.error("API returned success: false");
          setFilteredSubCategories([]);
        }
      }
    } catch (error) {
      console.error("Error fetching subcategories for category:", error);
      setFilteredSubCategories([]);
      showErrorToast("Failed to fetch subcategories");
    }
  };

  const handleCloseSubCategoryView = () => {
    setShowSubCategoryView(false);
    setSearchTerm("");
  };

  // const fetchBrandColor = async () => {
  //   try {
  //     if (userId) {
  //       const res = await axios.get(`/auth/aiform/all/${userId}`);

  //       const data = res.data?.UserData?.brandColor;
  //       if (data) {
  //         setButtonColor(data);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchWayfinderData = async () => {
    // if (fetchedData.current.wayfinder) return;

    setIsLoading(true);
    try {
      const categoriesResponse = await axios.get(
        `/api/wayfinder/get-categories/${userId}`,
      );
      console.log("cat resp", categoriesResponse);
      if (!categoriesResponse.data.error) {
        const frontendCatNames = (categoriesResponse.data?.data || []).map(
          (fc) => ({
            ...fc,
            matchedCategoryName: fc?.linkedLocation
              ? `(${fc?.linkedLocation})`
              : "",
          }),
        );
        setFrontendCategories(frontendCatNames);

        setFrontendSubCategories(categoriesResponse.data?.data || []);
        setCategories(categoriesResponse.data?.data.categories || []);
      }

      // Fetch subcategories
      const subcategoriesResponse = await axios.get(
        `/api/wayfinder/subcategory/${userId}`,
      );
      if (!subcategoriesResponse.data.error) {
        setAllCategories(subcategoriesResponse.data?.data || []);
      }

      fetchedData.current.wayfinder = true;
    } catch (error) {
      console.error("Error fetching wayfinder data:", error);
      showErrorToast("Failed to load wayfinder data");
    } finally {
      setIsLoading(false);
    }
  };

  const createFrontItem = async (
    frontState,
    api,
    setFrontState,
    fetchFunction,
    type,
  ) => {
    if (!frontState.trim()) return;
    axios
      .post(`/api/wayfinder/${api}`, {
        name: frontState,
        userId: userId,
      })
      .then((response) => {
        if (!response.data.error) {
          fetchFunction();
          setFrontState("");
          showMsgSuccessToast(`${type} created successfully!`);
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  const toggleSubCategoryVisibility = (subcategoryId, isVisible) => {
    axios
      .patch(`/api/wayfinder/subcategory/${subcategoryId}/status`, {
        userId: userId,
        status: !isVisible,
      })
      .then((response) => {
        if (!response.data.error) {
          setFilteredSubCategories((prev) =>
            prev.map((sub) =>
              sub._id === subcategoryId ? { ...sub, status: !isVisible } : sub,
            ),
          );

          showMsgSuccessToast(
            `Subcategory ${!isVisible ? "activated" : "deactivated"} successfully!`,
          );
        } else {
          showErrorToast(response.data?.msg);
        }
      });
  };

  const handleUnlinkSubCategory = async (subcategoryId, categoryId) => {
    try {
      const response = await axios.post(`/api/wayfinder/subcategory/unlink`, {
        subcategoryId: subcategoryId,
        categoryId: categoryId,
        userId: userId,
      });

      if (response.data.success) {
        // Refresh the subcategories for this specific category
        await handleFetchLinkingSubCategory(categoryId);
        showMsgSuccessToast("Subcategory unlinked successfully!");
      } else {
        showErrorToast(
          response.data?.message || "Failed to unlink subcategory",
        );
      }
    } catch (error) {
      console.error("Error unlinking subcategory:", error);
      showErrorToast("Failed to unlink subcategory");
    }
  };

  const deleteSubCategory = async (subcategoryId, categoryId) => {
    try {
      const response = await axios.delete(
        `/api/wayfinder/delete-wayfinder-subCategory/${subcategoryId}`,
        {
          data: { userId },
        },
      );

      if (!response.data.error) {
        // Refresh the subcategories for this specific category
        await handleFetchLinkingSubCategory(categoryId);
        showMsgSuccessToast("Subcategory deleted successfully!");
      } else {
        showErrorToast(response.data?.msg);
      }
    } catch (error) {
      console.error("Error deleting subcategory:", error);
      showErrorToast("Failed to delete subcategory");
    }
  };

  const toggleCategoryVisibility = (
    categoryId,
    isVisible,
    frontend = false,
  ) => {
    axios
      .patch(
        `/api/wayfinder/wayfinder-category-visibility/${userId}/${categoryId}/status`,
        {
          userId,
          categoryId,
          status: !isVisible,
          frontend,
        },
      )
      .then((response) => {
        if (response.data.success) {
          setFrontendCategories((prev) =>
            prev.map((cat) =>
              cat._id === categoryId ? { ...cat, status: !isVisible } : cat,
            ),
          );

          showMsgSuccessToast(
            `Category ${!isVisible ? "activated" : "deactivated"} successfully!`,
          );
        }
      })
      .catch(() => {
        showErrorToast("Failed to update category visibility");
      });
  };

  const deleteCategory = (categoryId, frontend = false) => {
    axios
      .delete(`/api/wayfinder/delete-wayfinder-category/${categoryId}`, {
        categoryId,
        userId: userId,
        frontend,
      })
      .then(() => {
        setFrontendCategories((prev) =>
          prev.filter((cat) => cat._id !== categoryId),
        );
        setCategories((prev) => prev.filter((cat) => cat._id !== categoryId));
        showMsgSuccessToast("Category deleted successfully!");
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
        showErrorToast("Failed to delete category");
      });
  };

  const handleCreateSubCategoryFromView = async (
    subcategoryData,
    categoryId,
  ) => {
    try {
      const response = await axios.post("/api/wayfinder/subcategory", {
        userId: userId,
        ...subcategoryData,
        status: true,
        categoryId,
        currentLanguage: currentLanguage,
      });

      if (!response.data.error) {
        // Refresh the subcategories for this specific category
        await handleFetchLinkingSubCategory(categoryId);

        // Also refresh all subcategories list
        const subcategoriesResponse = await axios.get(
          `/api/wayfinder/subcategory/${userId}`,
        );
        if (!subcategoriesResponse.data.error) {
          setAllCategories(subcategoriesResponse.data?.data || []);
        }

        showMsgSuccessToast("Subcategory created successfully!");
      } else {
        showErrorToast(response.data?.msg);
      }
    } catch (error) {
      console.error("Error creating subcategory:", error);
      showErrorToast("Failed to create subcategory");
    }
  };

  const handleLinkExistingSubCategory = async (subcategoryIds, categoryId) => {
    try {
      const response = await axios.post(
        `/api/wayfinder/subcategory/bulk-link`,
        {
          subcategoryIds: subcategoryIds,
          categoryId: categoryId,
          userId: userId,
        },
      );

      if (response.data.success) {
        const { linked, alreadyLinked } = response.data.data;

        // Refresh the subcategories for this specific category FIRST
        await handleFetchLinkingSubCategory(categoryId);

        // Also refresh the main wayfinder data in background (don't await)
        fetchWayfinderData();

        if (linked && linked.length > 0) {
          showMsgSuccessToast(
            `Successfully linked ${linked.length} subcategory(ies)`,
          );
        }
        if (alreadyLinked && alreadyLinked.length > 0) {
          showMsgSuccessToast(
            `${alreadyLinked.length} subcategory(ies) were already linked`,
          );
        }
      } else {
        showErrorToast(
          response.data?.message || "Failed to link subcategories",
        );
      }
    } catch (error) {
      console.error("Error linking subcategories:", error);
      showErrorToast("Failed to link subcategories");
    }
  };

  // Add these state variables for locations
  const [locations, setLocations] = useState([]);
  const [showSubLocationView, setShowSubLocationView] = useState(false);
  const [allLocations, setAllLocations] = useState([]);
  const [allSubLocations, setAllSubLocations] = useState([]);

  const fetchLocations = async () => {
    if (fetchedData.current.locations) return; // Prevent duplicate fetch

    setIsLoading(true);
    try {
      const response = await axios.get(
        `/api/wayfinder/get-locations/${userId}`,
      );
      console.log("Locations response:", response);
      if (response.data.success) {
        setLocations(response.data.data || []);
        setAllLocations(response.data.data || []);
      }
      fetchedData.current.locations = true;
    } catch (error) {
      console.error("Error fetching locations:", error);
      showErrorToast("Failed to load locations");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSublocations = async () => {
    if (fetchedData.current.sublocations) return; // Prevent duplicate fetch

    setIsLoading(true);
    try {
      const response = await axios.get(`/api/wayfinder/sublocations/${userId}`);
      console.log("Sublocations response:", response);
      if (response.data.success) {
        setAllSubLocations(response.data.data || []);
      }
      fetchedData.current.sublocations = true;
    } catch (error) {
      console.error("Error fetching sublocations:", error);
      showErrorToast("Failed to load sublocations");
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch user data for menu URL and brand color
  const fetchUserData = async () => {
    try {
      const res = await axios.get(`/auth/aiform/all/${userId}`);
      const data = res.data?.UserData?.menu_client_url;
      const brandColor = res.data?.UserData?.brandColor;
      if (data) {
        setMenuUrl(data);
        setButtonColor(brandColor);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch client settings to check feature access
  const fetchClientSettings = async () => {
    try {
      const res = await axios.get(`/auth/settings/client/${userId}`);
      const featureAccess = res.data?.settings?.featureAccess;
      setWayfinderEnabled(featureAccess?.wayfinderEnabled || false);
    } catch (error) {
      console.error("Error fetching client settings:", error);
      setWayfinderEnabled(false);
    }
  };

  // Create a new category with multilanguage support
  const createCategory = async (categoryName) => {
    if (!categoryName.trim()) return; // Prevent empty category creation

    try {
      const response = await axios.post("/api/wayfinder/categories", {
        name: categoryName,
        userId: userId,
        currentLanguage: currentLanguage,
        status: true,
      });

      if (response.data.success) {
        await fetchWayfinderData(); // Refresh categories
        showMsgSuccessToast("Category created successfully!");
        return response.data.data;
      } else {
        showErrorToast(response.data?.message || "Failed to create category");
      }
    } catch (error) {
      console.error("Error creating category:", error);
      showErrorToast("Failed to create category");
    }
  };

  // Create a new location with multilanguage support
  const createLocation = async (locationName) => {
    if (!locationName.trim()) return; // Prevent empty location creation

    try {
      const response = await axios.post("/api/wayfinder/locations", {
        name: locationName,
        userId: userId,
        currentLanguage: currentLanguage,
        status: true,
      });

      if (response.data.success) {
        await fetchLocations(); // Refresh locations
        showMsgSuccessToast("Location created successfully!");
        return response.data.data;
      } else {
        showErrorToast(response.data?.message || "Failed to create location");
      }
    } catch (error) {
      console.error("Error creating location:", error);
      showErrorToast("Failed to create location");
    }
  };

  // Fetch data based on active tab
  useEffect(() => {
    if (!userId) return;

    const currentTabValue = getCurrentTabValue();
    const actualValue = wayfinderEnabled ? currentTabValue - 1 : currentTabValue;

    // Category Manager tab (0)
    if (actualValue === 0) {
      fetchWayfinderData();
    }
    // Main Category Settings tab (1)
    else if (actualValue === 1) {
      fetchCategoryData();
      // fetchTextData("category");
    }
    // Main SubCategory Settings tab (2)
    // else if (actualValue === 2) {
    //   // fetchSubCategoryData();
    //   // fetchSubCategoryTextData();
    // }
    // Location Manager tab (3)
    else if (actualValue === 2) {
      fetchLocations();
      // fetchSublocations();
    }
  }, [location.pathname, userId, wayfinderEnabled]);

  const handleUpload = async (file, position) => {
    if (!file) {
      showErrorToast(`Please select a file for ${position} first!`);
      return;
    }

    setUploadingStates((prev) => ({ ...prev, [position]: true }));

    try {
      // Upload to S3
      const fileUrl = await uploadToS3(file);

      setUploadedUrls((prev) => ({
        ...prev,
        [position]: {
          fileName: file.name,
          fileUrl: fileUrl,
          enabled: true,
          width: prev[position]?.width || 100,
          height: prev[position]?.height || 100,
        },
      }));
    } catch (error) {
      console.error("Upload failed:", error);
      showErrorToast(`Failed to upload ${position}`);
    } finally {
      setUploadingStates((prev) => ({ ...prev, [position]: false }));
    }
  };

  const handleDeleteLogo = async (position) => {
    try {
      setUploadedUrls((prev) => ({
        ...prev,
        [position]: {
          ...prev[position],
          fileName: "",
          fileUrl: "",
          enabled: false,
        },
      }));
      showMsgSuccessToast("Logo removed successfully");
    } catch (error) {
      showErrorToast("Failed to remove logo");
    }
  };

  const handleToggleChangeMedia = (position, on) => {
    setUploadedUrls((prev) => ({
      ...prev,
      [position]: {
        ...((prev || {})[position] || {}),
        enabled: on,
      },
    }));
  };

  const handleSave = async () => {
    try {
      setLoadingMedia(true);
      const response = await axios.post(
        `/api/wayfinder/save-main-category-media/${userId}`,
        {
          uploadedUrls,
          status: categoryData.status,
        },
      );
      if (response.data.success) {
        showMsgSuccessToast("Category media settings saved successfully!");
      } else {
        showErrorToast(response.data.message || "Failed to save");
      }
    } catch (error) {
      console.error("Error saving category media:", error);
      showErrorToast("Failed to save category media settings");
    } finally {
      setLoadingMedia(false);
    }
  };

  const fetchCategoryData = async () => {
    if (fetchedData.current.categoryMedia) return; // Prevent duplicate fetch

    try {
      setLoadingMedia(true);
      const response = await axios.get(
        `/api/wayfinder/main-category/${userId}`,
      );
      if (response.data.success) {
        const data = response.data.data;

        console.log("datadsajdsa", data);

        setCategoryData({
          status: data.status || true,
          videoTime: data.videoTime || 0,
        });

        console.log("main urls", uploadedUrls);

        const updatedUrls = { ...uploadedUrls };
        Object.keys(data.uploadedUrls || {}).forEach((position) => {
          if (data.uploadedUrls[position]) {
            updatedUrls[position] = {
              fileName: data.uploadedUrls[position].fileName || "",
              fileUrl: data.uploadedUrls[position].fileUrl || "",
              enabled: data.uploadedUrls[position].enabled || false,
              width: data.uploadedUrls[position].width || "100",
              height: data.uploadedUrls[position].height || "100",
            };
          }
        });

        console.log("updated Urls", updatedUrls);

        setUploadedUrls(updatedUrls);
      }
      fetchedData.current.categoryMedia = true;
    } catch (error) {
      console.error("Error fetching category data:", error);
      showErrorToast("Failed to load category data");
    } finally {
      setLoadingMedia(false);
    }
  };

  // Fetch only essential data on mount
  useEffect(() => {
    if (userId && !isEffectRan.current) {
      isEffectRan.current = true;
      // fetchBrandColor(); // Always needed for UI
      fetchUserData(); // Always needed for header
      fetchClientSettings(); // Always needed for tabs
      fetchAvailableLanguages(); // Fetch available languages
    }
  }, [userId]);

  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({
    numColumns: 1,
    columnSpacing: 10,
    enableOffset: true,
    leftOffset: 5,
    rightOffset: 0,
    topOffset: 5,
    disableAnimation: false,
    buttonAlignment: "center",
  });

  // Load settings when userId changes
  // Fetch category settings only when Category Manager tab is active
  useEffect(() => {
    const currentTabValue = getCurrentTabValue();
    const actualValue = wayfinderEnabled ? currentTabValue - 1 : currentTabValue;
    if (userId && actualValue === 0) {
      fetchSettings();
    }
  }, [location.pathname, userId, wayfinderEnabled]);

  const fetchSettings = async () => {
    if (fetchedData.current.settings) return; // Prevent duplicate fetch

    try {
      const response = await axios.get(
        `/api/wayfinder/frontend-main-category-settings/${userId}`,
      );
      if (response.data.success) {
        const settings = response.data.data;
        setConfig((prev) => ({
          ...prev,
          ...settings,
        }));
      }
      fetchedData.current.settings = true;
    } catch (error) {
      console.error("Error fetching category settings:", error);
    }
  };

  const handleSavePanelSettings = async (newConfig) => {
    try {
      const response = await axios.post(
        `/api/wayfinder/frontend-main-category-settings/${userId}`,
        {
          ...newConfig,
          userId: userId,
        },
      );

      if (response.status === 200) {
        console.log("Settings saved successfully:", response.data);
        return { success: true, data: response.data };
      }

      return { success: false, error: "Failed to save settings" };
    } catch (error) {
      console.error("Error saving settings:", error);
      return {
        success: false,
        error: error.response?.data?.error || "Failed to save settings",
      };
    }
  };

  const openPanel = () => setIsOpen(true);
  const closePanel = () => setIsOpen(false);

  // SubCategory Settings Panel State
  const [isSubCategoryPanelOpen, setIsSubCategoryPanelOpen] = useState(false);
  const [subCategoryConfig, setSubCategoryConfig] = useState({
    numColumns: "center-two-buttons-per-row",
    columnSpacing: 5,
    buttonGap: 10,
    enableOffset: false,
    leftOffset: 5,
    rightOffset: 0,
    topOffset: 5,
    disableAnimation: false,
    buttonAlignment: "center",
    buttonMarginTop: 0,
    buttonMarginBottom: 0,
  });

  const fetchSubCategorySettings = async () => {
    if (fetchedData.current.subCategorySettings) return; // Prevent duplicate fetch

    try {
      const response = await axios.get(
        `/api/wayfinder/frontend-main-subcategory-settings/${userId}`,
      );
      if (response.data.success) {
        const settings = response.data.data;
        setSubCategoryConfig((prev) => ({
          ...prev,
          ...settings,
        }));
      }
      fetchedData.current.subCategorySettings = true;
    } catch (error) {
      console.error("Error fetching subcategory settings:", error);
    }
  };

  const handleSaveSubCategoryPanelSettings = async (newConfig) => {
    try {
      const response = await axios.post(
        `/api/wayfinder/frontend-main-subcategory-settings/${userId}`,
        {
          ...newConfig,
          userId: userId,
        },
      );

      if (response.status === 200) {
        console.log("SubCategory settings saved successfully:", response.data);
        showMsgSuccessToast("SubCategory settings saved successfully");
        return { success: true, data: response.data };
      }

      return { success: false, error: "Failed to save settings" };
    } catch (error) {
      console.error("Error saving subcategory settings:", error);
      showErrorToast("Failed to save subcategory settings");
      return {
        success: false,
        error: error.response?.data?.error || "Failed to save settings",
      };
    }
  };

  const openSubCategoryPanel = () => {
    fetchSubCategorySettings();
    setIsSubCategoryPanelOpen(true);
  };
  const closeSubCategoryPanel = () => setIsSubCategoryPanelOpen(false);

  // Fetch button settings only if id exists (not needed for most tabs)
  // useEffect(() => {
  //   if (!id || !userId) return;

  //   fetch(`/api/button-settings/${id}/${userId}`)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (!data.error) {
  //         const result = data?.data;
  //         setSettings((prevSettings) => ({
  //           ...prevSettings,
  //           globalSettings: {
  //             ...prevSettings?.globalSettings,
  //             ...result?.globalSettings,
  //           },
  //           customSettings: {
  //             ...prevSettings?.customSettings,
  //             ...result?.customSettings,
  //           },
  //           enabled: result?.enabled,
  //           btnId: id,
  //           buttonText: result?.buttonText,
  //         }));

  //         setMenuUrl(data?.menu_client_url);

  //         if (
  //           result?.menuLevel === "primary" ||
  //           result?.menuLevel === "frontend"
  //         ) {
  //           setIsPrimary(true);
  //         }

  //         setMenuLevel(result?.menuLevel);
  //         setParentMenuName(result?.parentMenuName);
  //         setChildMenuName(result?.chilmenuName);
  //         SetParentMenuID(result?.parentMenuID);
  //         setLinkedBtnId(result?.linkbtnId);
  //         setMainMeuLinked(result?.mainMeuLinked);
  //       }
  //     })
  //     .catch(() => console.log("Button not found, creating new settings."));
  // }, [id, userId]);

  const handleTextSectionChange = (sectionType, section, field, value) => {
    setMainTextSections((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleToggleTextSection = (sectionType, section) => {
    setMainTextSections((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        enabled: !prev[section].enabled,
      },
    }));
  };

  const handleSearchConfigChange = (sectionType, field, value) => {
    if (field === "searchConfig") {
      setMainTextSections((prev) => ({
        ...prev,
        searchConfig: value,
      }));
    } else {
      setMainTextSections((prev) => ({
        ...prev,
        searchConfig: {
          ...prev.searchConfig,
          [field]: value,
        },
      }));
    }
  };

  const fetchTextData = async (sectionType) => {
    if (fetchedData.current.categoryText) return; // Prevent duplicate fetch

    try {
      setLoadingText(true);
      const endpoint = `/api/wayfinder/get-main-category-text/${userId}`;

      const response = await axios.get(endpoint);
      if (response.data.success) {
        const data = response.data.data;

        setMainTextSections((prev) => ({
          header: data.header || prev.header,
          description: data.description || prev.description,
          footer: data.footer || prev.footer,
          searchConfig: data.searchConfig || prev.searchConfig,
        }));
      }
      fetchedData.current.categoryText = true;
    } catch (error) {
      console.error(`Error fetching ${sectionType} text data:`, error);
      showErrorToast(`Failed to load ${sectionType} text data`);
    } finally {
      setLoadingText(false);
    }
  };

  const saveTextData = async (sectionType, sections) => {
    try {
      setLoadingText(true);
      const endpoint = `/api/wayfinder/save-main-category-text/${userId}`;

      const response = await axios.post(endpoint, sections);
      if (response.data.success) {
        showMsgSuccessToast("Category text settings saved successfully!");
      } else {
        showErrorToast(response.data.message || "Failed to save");
      }
    } catch (error) {
      console.error(`Error saving ${sectionType} text:`, error);
      showErrorToast(`Failed to save ${sectionType} text settings`);
    } finally {
      setLoadingText(false);
    }
  };

  // SubCategory handlers
  const handleUploadSubCategory = async (file, position) => {
    if (!file) {
      showErrorToast(`Please select a file for ${position} first!`);
      return;
    }

    setUploadingStatesSubCategory((prev) => ({ ...prev, [position]: true }));

    try {
      // Upload to S3
      const fileUrl = await uploadToS3SubCategory(file);

      setUploadedUrlsSubCategory((prev) => ({
        ...prev,
        [position]: {
          fileName: file.name,
          fileUrl: fileUrl,
          enabled: true,
          width: prev[position]?.width || 100,
          height: prev[position]?.height || 100,
        },
      }));
    } catch (error) {
      console.error("Upload failed:", error);
      showErrorToast(`Failed to upload ${position}`);
    } finally {
      setUploadingStatesSubCategory((prev) => ({
        ...prev,
        [position]: false,
      }));
    }
  };

  const handleDeleteLogoSubCategory = async (position) => {
    try {
      setUploadedUrlsSubCategory((prev) => ({
        ...prev,
        [position]: {
          ...prev[position],
          fileName: "",
          fileUrl: "",
          enabled: false,
        },
      }));
      showMsgSuccessToast("Logo removed successfully");
    } catch (error) {
      showErrorToast("Failed to remove logo");
    }
  };

  const handleToggleChangeMediaSubCategory = (position, on) => {
    setUploadedUrlsSubCategory((prev) => ({
      ...prev,
      [position]: {
        ...((prev || {})[position] || {}),
        enabled: on,
      },
    }));
  };

  const handleSaveSubCategory = async () => {
    try {
      setLoadingMediaSubCategory(true);
      const response = await axios.post(
        `/api/wayfinder/save-main-subcategory/${userId}`,
        {
          uploadedUrls: uploadedUrlsSubCategory,
          status: subCategoryData.status,
        },
      );
      if (response.data.success) {
        showMsgSuccessToast("SubCategory media settings saved successfully!");
      } else {
        showErrorToast(response.data.message || "Failed to save");
      }
    } catch (error) {
      console.error("Error saving subcategory media:", error);
      showErrorToast("Failed to save subcategory media settings");
    } finally {
      setLoadingMediaSubCategory(false);
    }
  };

  const fetchSubCategoryData = async () => {
    if (fetchedData.current.subcategoryMedia) return; // Prevent duplicate fetch

    try {
      setLoadingMediaSubCategory(true);
      const response = await axios.get(
        `/api/wayfinder/main-subcategory/${userId}`,
      );
      if (response.data.success) {
        const data = response.data.data;

        setSubCategoryData({
          status: data.status || true,
          videoTime: data.videoTime || 0,
        });

        const updatedUrls = { ...uploadedUrlsSubCategory };
        Object.keys(data.uploadedUrls || {}).forEach((position) => {
          if (data.uploadedUrls[position]) {
            updatedUrls[position] = {
              fileName: data.uploadedUrls[position].fileName || "",
              fileUrl: data.uploadedUrls[position].fileUrl || "",
              enabled: data.uploadedUrls[position].enabled || false,
              width: data.uploadedUrls[position].width || "100",
              height: data.uploadedUrls[position].height || "100",
            };
          }
        });

        setUploadedUrlsSubCategory(updatedUrls);
      }
      fetchedData.current.subcategoryMedia = true;
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
      showErrorToast("Failed to load subcategory data");
    } finally {
      setLoadingMediaSubCategory(false);
    }
  };

  const handleSubCategoryTextSectionChange = (
    sectionType,
    section,
    field,
    value,
  ) => {
    setMainSubCategoryTextSections((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleToggleSubCategoryTextSection = (sectionType, section) => {
    setMainSubCategoryTextSections((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        enabled: !prev[section].enabled,
      },
    }));
  };

  const handleSubCategorySearchConfigChange = (sectionType, field, value) => {
    if (field === "searchConfig") {
      setMainSubCategoryTextSections((prev) => ({
        ...prev,
        searchConfig: value,
      }));
    } else {
      setMainSubCategoryTextSections((prev) => ({
        ...prev,
        searchConfig: {
          ...prev.searchConfig,
          [field]: value,
        },
      }));
    }
  };

  const fetchSubCategoryTextData = async () => {
    if (fetchedData.current.subcategoryText) return; // Prevent duplicate fetch

    try {
      setLoadingTextSubCategory(true);
      const endpoint = `/api/wayfinder/get-main-subcategory-text/${userId}`;

      const response = await axios.get(endpoint);
      if (response.data.success) {
        const data = response.data.data;

        setMainSubCategoryTextSections((prev) => ({
          header: data.header || prev.header,
          description: data.description || prev.description,
          footer: data.footer || prev.footer,
          searchConfig: data.searchConfig || prev.searchConfig,
        }));
      }
      fetchedData.current.subcategoryText = true;
    } catch (error) {
      console.error("Error fetching subcategory text data:", error);
      showErrorToast("Failed to load subcategory text data");
    } finally {
      setLoadingTextSubCategory(false);
    }
  };

  const saveSubCategoryTextData = async (sectionType, sections) => {
    try {
      setLoadingTextSubCategory(true);
      const endpoint = `/api/wayfinder/save-main-subcategory-text/${userId}`;

      const response = await axios.post(endpoint, sections);
      if (response.data.success) {
        showMsgSuccessToast("SubCategory text settings saved successfully!");
      } else {
        showErrorToast(response.data.message || "Failed to save");
      }
    } catch (error) {
      console.error("Error saving subcategory text:", error);
      showErrorToast("Failed to save subcategory text settings");
    } finally {
      setLoadingTextSubCategory(false);
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px dashboard-container">
          {/* Header Section */}
          <div className="page-header" style={{ marginBottom: "24px" }}>
            <div className="row">
              <div className="col-md-3 col-sm-12">
                <div className="title">
                  <Typography variant="h4">
                    Wayfinder
                    {menuUrl && (
                      <>
                        <Typography
                          component="span"
                          sx={{ fontWeight: "bold", mx: 1 }}
                        >
                          &gt;&gt;
                        </Typography>
                        {menuUrl.charAt(0).toUpperCase() + menuUrl.slice(1)}
                      </>
                    )}
                  </Typography>
                </div>
              </div>

              {/* Language Switcher */}
              <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-center">
                {loadingLanguages ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span>Loading languages...</span>
                  </div>
                ) : availableLanguages.length > 1 ? (
                  <div className="language-switcher">
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
                        type="button"
                        id="languageDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          borderColor: buttonColor,
                          color: buttonColor,
                          backgroundColor: "transparent",
                        }}
                      >
                        <span
                          className={`fi fi-${getLanguageFlag(currentLanguage)} me-2`}
                          style={{ fontSize: "16px" }}
                        ></span>
                        <span className="me-1">
                          {getLanguageName(currentLanguage)}
                        </span>
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                        {availableLanguages.map((lang) => (
                          <li key={lang}>
                            <button
                              className={`dropdown-item d-flex align-items-center ${lang === currentLanguage ? "active" : ""
                                }`}
                              onClick={() => handleLanguageChange(lang)}
                              style={{
                                backgroundColor:
                                  lang === currentLanguage ? buttonColor : "transparent",
                                color: lang === currentLanguage ? "#fff" : "#000",
                              }}
                            >
                              <span
                                className={`fi fi-${getLanguageFlag(lang)} me-2`}
                                style={{ fontSize: "16px" }}
                              ></span>
                              {getLanguageName(lang)}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-md-6 col-sm-12">
                <button
                  type="button"
                  onClick={goBack}
                  style={{ float: "right", backgroundColor: buttonColor }}
                  className="btn btn-success"
                >
                  {`<< Back`}
                </button>
              </div>
            </div>
          </div>

          {/* Main Tabs */}
          <Tabs
            value={getCurrentTabValue()}
            onChange={handleTabChange}
            aria-label="wayfinder tabs"
            sx={{
              "& .MuiTab-root": { minWidth: 100 },
              "& .Mui-selected": { fontWeight: "bold" },
            }}
          >
            {wayfinderEnabled && (
              <Tab
                sx={{
                  "&:hover": {
                    backgroundColor: buttonColor,
                    color: "#fff",
                    fontWeight: "bold",
                  },
                }}
                label="Main Menu"
              />
            )}

            <Tab
              onClick={() => navigate(`/wayfinder/${userId}`)}
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Category's"
            />

            {/* <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Main Category Settings"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Main Sub Category Settings"
            /> */}

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Locations"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="All Locations"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Branding & QR"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Mobile"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Global"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Avatar API"
            />

            {/* <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Location Orders"
            /> */}

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="MAP"
            />


            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Captions"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="Videos"
            />

            <Tab
              sx={{
                "&:hover": {
                  backgroundColor: buttonColor,
                  color: "#fff",
                  fontWeight: "bold",
                },
              }}
              label="TAGS"
            />


          </Tabs>

          {/* Tab Content */}
          <Box sx={{ p: 4, bgcolor: "background.paper" }}>
            {getCurrentTabValue() === 0 && wayfinderEnabled && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="400px"
              >
                <Typography variant="body1" color="text.secondary">
                  Redirecting to Main Menu Items...
                </Typography>
              </Box>
            )}

            {((getCurrentTabValue() === 0 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 1 && wayfinderEnabled)) && (
                <>
                  <Box
                    sx={{
                      minHeight: "100vh",
                      width: "100%",
                    }}
                  >
                    <Grid container spacing={3} justifyContent="center">
                      <Grid
                        item
                        xs={12}
                        lg={8}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        {/* Categories Card - Always Visible */}
                        <div
                          className="menu-card"
                          style={{ padding: "20px", marginBottom: "20px" }}
                        >
                          <div className="menu-title">
                            <span>{"Categories"}</span>
                            <MuiTooltip title="Main Category Settings">
                              { /*  <Link to={`#`} onClick={() => setIsOpen(!isOpen)}>
                              <span className="bi bi-gear micon"></span>
                            </Link> */}
                            </MuiTooltip>
                          </div>

                          <WayfinderCard
                            items={filteredCategories}
                            userId={userId}
                            buttonColor={buttonColor}
                            placeholder="Enter new category name"
                            inputValue={frontCategoryName}
                            onInputChange={(e) =>
                              setFrontCategoryName(e.target.value)
                            }
                            onSubmit={async () => {
                              if (frontCategoryName.trim()) {
                                await createCategory(frontCategoryName);
                                setFrontCategoryName("");
                              }
                            }}
                            handleToggleVisibility={(id, isVisible) =>
                              toggleCategoryVisibility(id, isVisible, true)
                            }
                            onDelete={(id) => deleteCategory(id, true)}
                            type="category"
                            submitButtonText="+"
                            onViewSubCategories={handleViewSubCategories}
                            currentLanguage={currentLanguage}
                          />
                        </div>

                        {/* Subcategories Card - Shows Below When Opened */}
                        {showSubCategoryView && (
                          <Fade in={showSubCategoryView}>
                            <Paper
                              sx={{
                                borderRadius: 3,
                                border: "1px solid #ddd",
                                width: "100%",
                                mb: 4,
                                maxWidth: "800px",
                              }}
                            >
                              <SubCategoryView
                                category={selectedCategoryForSubView}
                                onClose={handleCloseSubCategoryView}
                                userId={userId}
                                buttonColor={buttonColor}
                                existingSubCategories={frontendSubCategories}
                                allSubCategories={allSubCategories}
                                onCreateNew={handleCreateSubCategoryFromView}
                                onLinkExisting={handleLinkExistingSubCategory}
                                onUnlink={handleUnlinkSubCategory}
                                handleToggleVisibility={(id, isVisible) =>
                                  toggleSubCategoryVisibility(id, isVisible)
                                }
                                onDelete={(subcategoryId, categoryId) =>
                                  deleteSubCategory(subcategoryId, categoryId)
                                }
                                frontendCategories={frontendCategories}
                                selectedParentCategories={
                                  selectedParentCategories
                                }
                                setSelectedParentCategories={
                                  setSelectedParentCategories
                                }
                                toggleCategoryVisibility={
                                  toggleCategoryVisibility
                                }
                                deleteCategory={deleteCategory}
                                searchTerm={searchTerm}
                                onSearchChange={setSearchTerm}
                                filteredSubCategories={filteredSubCategories}
                                currentLanguage={currentLanguage}
                              />
                            </Paper>
                          </Fade>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                </>
              )}

            {isOpen && (
              <CategorySlidePanelForm
                type="main"
                isOpen={isOpen}
                onClose={closePanel}
                onSave={handleSavePanelSettings}
                config={config}
                setConfig={setConfig}
                buttonColor={buttonColor || "#000000"}
                title="Category Settings"
                userId={userId}
              />
            )}

            {/* {isSubCategoryPanelOpen && (
              <CategorySlidePanelForm
                type="sub"
                isOpen={isSubCategoryPanelOpen}
                onClose={closeSubCategoryPanel}
                onSave={handleSaveSubCategoryPanelSettings}
                config={subCategoryConfig}
                setConfig={setSubCategoryConfig}
                buttonColor={buttonColor || "#000000"}
                title="SubCategory Settings"
                userId={userId}
              />
            )} */}

            {/* {((value === 1 && !wayfinderEnabled) ||
              (value === 2 && wayfinderEnabled)) && (
              <>
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                    Main Category Settings
                  </Typography>

                  <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                      Media Settings
                    </Typography>
                    <MainWayfinderMedia
                      type="category"
                      userId={userId}
                      buttonColor={buttonColor}
                      title=""
                      uploadedUrls={uploadedUrls}
                      setUploadedUrls={setUploadedUrls}
                      uploadingStates={uploadingStates}
                      setUploadingStates={setUploadingStates}
                      handleUpload={handleUpload}
                      handleDeleteLogo={handleDeleteLogo}
                      handleSave={handleSave}
                      handleToggleChangeMedia={handleToggleChangeMedia}
                      loading={loadingMedia || s3Uploading}
                      categoryData={categoryData}
                      setCategoryData={setCategoryData}
                      fetchCategoryData={fetchCategoryData}
                      showSaveBtn={true}
                    />
                  </Box>

                  <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                      Text Settings
                    </Typography>
                    <MainTextPage
                      userId={userId}
                      buttonColor={buttonColor}
                      sectionType="category"
                      title=""
                      sections={mainTextSections}
                      loading={loadingText}
                      onSectionChange={(section, field, value) =>
                        handleTextSectionChange(
                          "category",
                          section,
                          field,
                          value,
                        )
                      }
                      onToggleSection={(section) =>
                        handleToggleTextSection("category", section)
                      }
                      onSearchConfigChange={(field, value) =>
                        handleSearchConfigChange("category", field, value)
                      }
                      onSave={() => saveTextData("category", mainTextSections)}
                    />
                  </Box>
                </Box>
              </>
            )}

            {((value === 2 && !wayfinderEnabled) ||
              (value === 3 && wayfinderEnabled)) && (
              <>
                <Box sx={{ mb: 4 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 3,
                    }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                      Main Sub Category Settings
                    </Typography>
                    <button
                      onClick={openSubCategoryPanel}
                      style={{
                        backgroundColor: buttonColor || "#000000",
                        color: "#ffffff",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      ⚙️ Layout Settings
                    </button>
                  </Box>

                  <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                      Media Settings
                    </Typography>
                    <MainWayfinderMedia
                      type="subcategory"
                      userId={userId}
                      buttonColor={buttonColor}
                      title=""
                      uploadedUrls={uploadedUrlsSubCategory}
                      setUploadedUrls={setUploadedUrlsSubCategory}
                      uploadingStates={uploadingStatesSubCategory}
                      setUploadingStates={setUploadingStatesSubCategory}
                      handleUpload={handleUploadSubCategory}
                      handleDeleteLogo={handleDeleteLogoSubCategory}
                      handleSave={handleSaveSubCategory}
                      handleToggleChangeMedia={
                        handleToggleChangeMediaSubCategory
                      }
                      loading={
                        loadingMediaSubCategory || s3UploadingSubCategory
                      }
                      categoryData={subCategoryData}
                      setCategoryData={setSubCategoryData}
                      fetchCategoryData={fetchSubCategoryData}
                      showSaveBtn={true}
                    />
                  </Box>

                  <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                      Text Settings
                    </Typography>
                    <MainTextPage
                      userId={userId}
                      buttonColor={buttonColor}
                      sectionType="subcategory"
                      title=""
                      sections={mainSubCategoryTextSections}
                      loading={loadingTextSubCategory}
                      onSectionChange={(section, field, value) =>
                        handleSubCategoryTextSectionChange(
                          "subcategory",
                          section,
                          field,
                          value,
                        )
                      }
                      onToggleSection={(section) =>
                        handleToggleSubCategoryTextSection(
                          "subcategory",
                          section,
                        )
                      }
                      onSearchConfigChange={(field, value) =>
                        handleSubCategorySearchConfigChange(
                          "subcategory",
                          field,
                          value,
                        )
                      }
                      onSave={() =>
                        saveSubCategoryTextData(
                          "subcategory",
                          mainSubCategoryTextSections,
                        )
                      }
                    />
                  </Box>
                </Box>
              </>
            )} */}

            {((getCurrentTabValue() === 1 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 2 && wayfinderEnabled)) && <MainLocationTab currentLanguage={currentLanguage} />}

            {((getCurrentTabValue() === 2 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 3 && wayfinderEnabled)) && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  minHeight="400px"
                >
                  <Typography variant="body1" color="text.secondary">
                    Redirecting to All Locations page...
                  </Typography>
                </Box>
              )}

            {((getCurrentTabValue() === 3 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 4 && wayfinderEnabled)) && (
                <BrandingSettings userId={userId} buttonColor={buttonColor} />
              )}

            {((getCurrentTabValue() === 4 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 5 && wayfinderEnabled)) && (
                <MobileScreenSettings
                  userId={userId}
                  buttonColor={buttonColor}
                  value={getCurrentTabValue()}
                />
              )}

            {((getCurrentTabValue() === 5 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 6 && wayfinderEnabled)) && (
                <GlobalWayfinderButtonSettings
                  userId={userId}
                  buttonColor={buttonColor}
                />
              )}

            {((getCurrentTabValue() === 6 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 7 && wayfinderEnabled)) && (
                <GlobalAvatarSettings userId={userId} buttonColor={buttonColor} />
              )}

            {/* 
            {((getCurrentTabValue() === 8 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 9 && wayfinderEnabled)) && (
              <LocationSelector
                brandColor={buttonColor}
                userId={userId}
                loading={false}
                title="Manage Global Locations"
              />
            )} */}

            {((getCurrentTabValue() === 7 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 8 && wayfinderEnabled)) && (
                <MapSettings userId={userId} buttonColor={buttonColor} />
              )}

            {((getCurrentTabValue() === 8 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 9 && wayfinderEnabled)) && (
                <BulkCaptionUpload userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />
              )}

            {((getCurrentTabValue() === 9 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 10 && wayfinderEnabled)) && (
                <BulkVideoUpload userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />
              )}

            {((getCurrentTabValue() === 10 && !wayfinderEnabled) ||
              (getCurrentTabValue() === 11 && wayfinderEnabled)) && (
                <TagManager userId={userId} buttonColor={buttonColor} currentLanguage={currentLanguage} />
              )}


          </Box>
        </div>
      </div>
    </div>
  );
};
